// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"73a38523","253":"c573c9a7","548":"98649ddc"}[chunkId] + ".chunk.css";
};